import $ from "jquery";

$('.feedback-form input[type="button"]').attr("value", "Image Upload");